import React from "react";

export default class Icon extends React.Component {
    render() {
        return (
            <span className="icon">
                <i className={this.props.iconName}></i>
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/icons/feature1-icon.jsx